<div class="d--f jc--sb ai--c mt-2">
  <div class="f-700 fs-20">Resources</div>
  <div class="d--f ai--c">
    <div class="fs-14">
      <mat-form-field class="search-field mr-2" color="primary" appearance="outline">
        <mat-icon matSuffix>search</mat-icon>
        <mat-label>Search</mat-label>
        <input [(ngModel)]="searchTerm" (input)="onSearchChange()" matInput type="text" />
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" (click)="openResourceForm($event)">
      <span> Add </span>
    </button>
  </div>
</div>

<div class="d--f mt-2">
  <div
    class="p-1 mr-2 pointer"
    (click)="switchType('hospital')"
    [ngClass]="{ 'active-border': activeType === 'hospital' }"
  >
    Hospitals
  </div>
  <div
    class="p-1 pointer"
    (click)="switchType('rep_company')"
    [ngClass]="{ 'active-border': activeType === 'rep_company' }"
  >
    Companies
  </div>
</div>

<div *ngIf="isLoading" class="d--f jc--c mt-3">
  <mat-spinner color="primary" diameter="50"></mat-spinner>
</div>

<div *ngIf="!isLoading && resources.length > 0">
  <div class="mt-4 card-container">
    <my-rep-resource-card
      *ngFor="let resource of resources; let i = index; trackBy: trackByFn"
      [resource]="resource"
      [pinkBg]="i % 2 === 0"
      (edit)="openResourceForm($event, resource)"
      (delete)="openDeleteConfirmation($event, resource)"
    ></my-rep-resource-card>
  </div>
  <mat-paginator
    [length]="totalLength"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>

<my-rep-empty-screen
  [options]="emptyScreenOptions"
  *ngIf="!isLoading && resources.length === 0"
></my-rep-empty-screen>
